import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

export const RulesWrapper = styled.div`
    width: 100%;
`;

export const Rules = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
    background-color: white;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
    padding: 16px;
    margin-bottom: 20px;

    @media (min-width: ${props => props.theme.widths.containerMaxWidth}) {
        margin: 0 0 24px;
    }

    & > div:last-child {
        margin-bottom: 0;
    }
`;

export const RulesTitle = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.large};
    color: ${props => props.theme.colours.textDark};
    margin-bottom: 16px;
`;

export const RulesStrong = styled.strong`
    font-weight: 600;
    color: ${props => props.theme.colours.textGreen};
`;

export const RulesNumber = styled.strong`
    font-weight: 600;
    color: ${props => props.theme.colours.textGreen};
    border-right: 1px solid ${props => props.theme.colours.textGreen};
    padding-right: 4px;
`;

export const Rule = styled.div`
    margin-bottom: 16px;
    line-height: ${props => props.theme.lineHeight.normal};
`;
